import { Injectable } from '@angular/core';
import { Subject } from 'rxjs-compat';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {

    private _darkTheme = new Subject<boolean>();
    isDarkTheme = this._darkTheme.asObservable();

    // public static default = 'light';

    // public get current(): string {
    //     return localStorage.getItem('theme') ?? ThemeService.default;
    // }


    setDarkTheme(isDarkTheme: boolean): void {
        localStorage.setItem('theme', isDarkTheme ? 'dark' : 'light');
        this._darkTheme.next(isDarkTheme);
    }
}
